export default "__VITE_ASSET__701caf2f__"